import React from "react";
import AMNSide from "../../Assets/images/AMN-Side.png";
import AMNBanner from "../../Assets/images/AMN-Banner.jpg";
import { websiteUrl } from "../../const/constants";
import { useNavigate } from "react-router-dom";

const MunasibatHighlights = ({ jashans }) => {
  const navigate = useNavigate();
  if (!jashans || jashans.length === 0) {
    return null; // Don't render anything if there are no jashans
  }

  return (
    <div className="flex flex-col items-center bg-primaryBG bg-cover bg-center bg-no-repeat py-10 lg:flex-row gap-4 md:gap-8 lg:gap-14 lg:mt-20 md:mt-18 mt-10 px-3 sm:px-6 md:px-10 lg:px-20 mb-10 rounded-3xl">
      {/* Side Images - Hidden on Mobile, Smaller on Desktop */}
      <img
        src={AMNSide}
        alt="AMN"
        className="hidden md:block w-32 h-32 opacity-40"
      />

      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full">
        {jashans.map((jashan, index) => (
          <div
            key={index}
            className="text-start flex flex-col justify-center max-w-[280px] md:max-w-sm rounded-2xl shadow-lg bg-white mx-auto transition-all duration-300 hover:shadow-xl hover:scale-105 cursor-pointer"
            onClick={() => navigate(`/munasibat/detail/${jashan.id}`)}
          >
            <img
              src={
                jashan.image
                  ? `${websiteUrl}/munasibaat/${jashan.image}`
                  : AMNBanner
              }
              alt={jashan.title}
              className="h-52 w-full object-cover rounded-t-2xl"
              loading="lazy"
            />
            <div className="px-5 mt-4 mb-5">
              <div className="flex justify-start gap-4 text-primary text-base md:text-lg lg:text-xl">
                <p>
                  {new Date(jashan.date).toLocaleDateString("ur-PK-u-nu-latn", {
                    month: "long",
                  })}
                </p>
                <p>{jashan.title}</p>
              </div>
              <div className="flex justify-start gap-4 text-base md:text-lg lg:text-xl">
                <p className="text-2xl">{new Date(jashan.date).getDate()}</p>
                <p>{jashan.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Side Images - Hidden on Mobile, Smaller on Desktop */}
      <img
        src={AMNSide}
        alt="AMN"
        className="hidden md:block w-32 h-32 opacity-40"
      />
    </div>
  );
};

export default MunasibatHighlights;
